import { z } from 'zod';

const zodChargeOrAllowanceApprovedPatchSchema = z.object({
  absoluteTotalApproved: z.number(),
  basisAmountApproved: z.number().optional(),
});

const zodEarlyPaymentDiscountApprovedPatchSchema = z.object({
  dueAmountApproved: z.number(),
});

const zodTaxCalculationApprovedPatchSchema = z.object({
  basisAmountApproved: z.number(),
  taxAmountApproved: z.number(),
});

export const zodUpdateInvoiceDataApprovedPayloadSchema = z.object({
  allowances: z.array(zodChargeOrAllowanceApprovedPatchSchema).optional(),
  charges: z.array(zodChargeOrAllowanceApprovedPatchSchema).optional(),
  dueAmountApproved: z.number(),
  generalAllowanceApproved: z.number(),
  grossAmountApproved: z.number(),
  netAmountApproved: z.number(),
  skonto: z.array(zodEarlyPaymentDiscountApprovedPatchSchema).optional(),
  taxAmountApproved: z.number(),
  taxCalculation: z.array(zodTaxCalculationApprovedPatchSchema).optional(),
});
